import React from "react";
import { PanelEditEmailTemplate } from "../../../UI/EmailTemplates/Edit/PanelEditEmailTemplate";


const EditEmailTemplate = () => {
  return (
    <div>
      <PanelEditEmailTemplate />
    </div>
  );
};

export default EditEmailTemplate;
